/** Created by azhou on 2019/3/18.*/
<template>
  <div class="d-center flex-column">
      <div class="d-center-start mb-3 w-50">
        <left-text leftText="当前手机号"/> {{userHeadInfo.mobile}}
      </div>
      <left-text-border required class="mb-3 w-50" leftText="新手机号" type="number" v-model="new_mobile"/>
      <div class="d-center-start mb-3 w-50">
        <left-text leftText="验证码" required/>
        <send-phone-code :phoneNumber="new_mobile" template="SMS_269200254" class="w-100" url="/pc/User/GetUpdateCode"
                         @showError="msg => this._alert(msg,null,'error')"
                         @getCode="code => this.sms_code = code"/>
      </div>
      <el-button type="primary" @click="submitForm">确定</el-button>
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'PhoneSet',
    computed: {
      ...mapState(['userHeadInfo'])
    },
    data() {
      return {
        new_mobile:'',
        sms_code:'',
      }
    },
    methods:{
      ...mapActions(['modifyPhone']),
      submitForm() {
        if (!this.new_mobile || !this. sms_code) {
          this._alert('手机号和验证码都不得为空',null,'error');
          return;
        }
        this.modifyPhone({
          data: {new_mobile: this.new_mobile, sms_code: this.sms_code},
          successFun(){
            location.reload()
          }
        });
      }
    }
  }
</script>

<style lang="scss">
.get-code {
  width: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: var(--smtc-color-primary);
  cursor: pointer;
  user-select: none;
}
</style>